import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformAdminWorkspaceService } from './platform-admin-workspace.service';
import { PlatformAdminPortalService } from './platform-admin-portal.service';

export const platformAdminPortalGuard: CanActivateFn = async (_route, state) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return true;
  }

  const workspace = inject(PlatformAdminWorkspaceService);
  const api = inject(PlatformAdminPortalService);
  const router = inject(Router);
  try {
    const resolved = await workspace.resolveSession();
    if (resolved) {
      return true;
    }
  } catch (error) {
    console.warn('[PlatformAdminPortalGuard] platform admin session lookup failed:', error);
  }

  if (api.hasRecentPlatformAdminLoginGrace()) {
    await wait(500);
    const settled = await workspace.resolveSession().catch(() => null);
    if (settled) {
      return true;
    }
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: safeReturnPath(state.url) },
  });
};

function safeReturnPath(value: string | null | undefined): string {
  if (!value || value.startsWith('http://') || value.startsWith('https://') || value.startsWith('//')) {
    return '/dashboard';
  }

  const path = value.startsWith('/') ? value : `/${value}`;
  return path === '/login' || path.startsWith('/login?') || path.startsWith('/login/')
    ? '/dashboard'
    : path;
}

function wait(delayMs: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, delayMs));
}
